/**
 * Chaves centralizadas de armazenamento.
 *
 * As credenciais protegidas por biometria e as do "Lembrar de mim" ficam em
 * services SEPARADOS de propósito: ler uma entrada protegida dispara o prompt
 * de Face ID/Digital, então o fluxo de prefill (plain) nunca pode esbarrar na
 * entrada biométrica.
 */
export const KEYCHAIN_SERVICE_BIOMETRIC = 'com.conecta.brasal.credentials.biometric';
export const KEYCHAIN_SERVICE_PLAIN = 'com.conecta.brasal.credentials.plain';

/**
 * Service usado antes da separação acima. Podia conter credenciais protegidas
 * por biometria, então nunca é lido (leitura dispararia o prompt) — apenas
 * apagado uma vez, para não deixar resíduo no keychain.
 */
export const KEYCHAIN_SERVICE_LEGACY = 'com.conecta.brasal.credentials';

export const StorageKeys = {
  BIOMETRIC_ENABLED: 'biometric_store',
} as const;
